export const VERIFY_EXTEND_RESULT_INFO_REQUEST = 'VERIFY_EXTEND_RESULT_INFO_REQUEST';
export const VERIFY_EXTEND_RESULT_INFO_SUCCESS = 'VERIFY_EXTEND_RESULT_INFO_SUCCESS';
export const VERIFY_EXTEND_RESULT_INFO_FAILURE = 'VERIFY_EXTEND_RESULT_INFO_FAILURE';

export function onVerifyExtendResultInfoRequest(productId) {
    return { type: VERIFY_EXTEND_RESULT_INFO_REQUEST, productId };
}

export function onVerifyExtendResultInfoSuccess({ currentAcademicYear, extendingResultsStatusType }) {
    return { type: VERIFY_EXTEND_RESULT_INFO_SUCCESS,
        currentAcademicYear,
        extendingResultsStatusType };
}

export function onVerifyExtendResultInfoFailure() {
    return { type: VERIFY_EXTEND_RESULT_INFO_FAILURE };
}

export const PROCESS_EXTEND_RESULT_REQUEST = 'PROCESS_EXTEND_RESULT_REQUEST';
export const PROCESS_EXTEND_RESULT_SUCCESS = 'PROCESS_EXTEND_RESULT_SUCCESS';
export const PROCESS_EXTEND_RESULT_FAILURE = 'PROCESS_EXTEND_RESULT_FAILURE';

export function onProceedExtendResultRequest() {
    return { type: PROCESS_EXTEND_RESULT_REQUEST };
}

export function onProceedExtendResultSuccess() {
    return { type: PROCESS_EXTEND_RESULT_SUCCESS };
}

export function onProceedExtendResultFailure() {
    return { type: PROCESS_EXTEND_RESULT_FAILURE };
}

export const CLOSE_EXTEND_RESULT_ERROR = 'CLOSE_EXTEND_RESULT_ERROR';

export function onCloseExtendResultError() {
    return { type: CLOSE_EXTEND_RESULT_ERROR };
}

export const SHOW_EXTEND_RESULT_INFO = 'SHOW_EXTEND_RESULT_INFO';

export function onShowExtendResultInfo() {
    return { type: SHOW_EXTEND_RESULT_INFO,
        showOkButton: true };
}

export const SET_IDS_TO_EXTEND = 'SET_IDS_TO_EXTEND';

export function setIdsToExtend(ids) {
    return { type: SET_IDS_TO_EXTEND, yearGroupsToBeExtended: ids };
}

export const EXTEND_RESULTS = 'EXTEND_RESULTS';
export const EXTEND_RESULTS_SUCCESS = 'EXTEND_RESULTS_SUCCESS';
export const EXTEND_RESULTS_FAILURE = 'EXTEND_RESULTS_FAILURE';

export function extendResults(selectedProductId, yeargroups) {
    const keys = Object.keys(yeargroups);
    const selectedYeargroups = keys.filter(key => yeargroups[key]);

    return { type: EXTEND_RESULTS, selectedProductId, selectedYeargroups };
}

export function extendResultsSuccess() {
    return { type: EXTEND_RESULTS_SUCCESS };
}

export function extendResultsFailure() {
    return { type: EXTEND_RESULTS_FAILURE };
}

export const CLOSE_EXTEND_RESULTS_MODAL = 'CLOSE_EXTEND_RESULTS_MODAL';

export function closeFailureModal() {
    return { type: CLOSE_EXTEND_RESULTS_MODAL };
}



// WEBPACK FOOTER //
// ./app/containers/extend-result/actions.js